export default __webpack_public_path__ + "static/media/ddsu5168-8.e6e0300b.png";